// extracted by mini-css-extract-plugin
module.exports = {"componentsTable":"componentTable_componentsTable__3K0cq","info":"componentTable_info__2f9CI"};